// Mirrors the hub's MEDIA_LIMITS (licensing-system portal-media.service.ts); the hub re-checks every upload.
export const MEDIA_TYPES = ["image/png", "image/jpeg", "image/webp"];

export const MEDIA_RULES = {
  icon: { maxBytes: 512 * 1024, minSide: 256, maxSide: 2048, square: true },
  screenshot: { maxBytes: 2 * 1024 * 1024, minSide: 32, maxSide: 4096, square: false }
};

export const formatBytes = (n) => (n >= 1024 * 1024 ? `${n / (1024 * 1024)} MB` : `${Math.round(n / 1024)} KB`);

export const isHttps = (value) => {
  try {
    return new URL(value).protocol === "https:";
  } catch (e) {
    return false;
  }
};

function dimensions(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

// Returns null when the file passes, else { key, params } for an `upload.errors.*` message.
export async function checkImage(file, kind, previewUrl) {
  const rule = MEDIA_RULES[kind];
  if (!MEDIA_TYPES.includes(file.type)) return { key: "type", params: {} };
  if (file.size > rule.maxBytes) return { key: "size", params: { max: formatBytes(rule.maxBytes) } };
  const size = await dimensions(previewUrl);
  if (!size) return { key: "type", params: {} };
  const { width, height } = size;
  if (Math.min(width, height) < rule.minSide || Math.max(width, height) > rule.maxSide || (rule.square && width !== height)) {
    return {
      key: rule.square ? "dimensionsSquare" : "dimensions",
      params: { min: rule.minSide, max: rule.maxSide, width, height }
    };
  }
  return null;
}
